import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  fetchPortalLeads,
  fetchLeadFilters,
  createPortalLead
} from "../../helpers/userportal_api";

//Include Both Helper File with needed methods
import {
  getContacts as getContactsApi,
  getCompanies as getCompaniesApi,
  getDeals as getDealsApi,
  addNewCompanies as addNewCompaniesApi,
  updateCompanies as updateCompaniesApi,
  deleteCompanies as deleteCompaniesApi,
  addNewContact as addNewContactApi,
  updateContact as updateContactApi,
  deleteContact as deleteContactApi,
  addNewLead as addNewLeadApi,
  updateLeadApi,
  deleteLead as deleteLeadApi
} from "../../helpers/fakebackend_helper";


export const getContacts = createAsyncThunk("crm/getContacts" , async (_, { rejectWithValue }) => {
  try{
    const response = getContactsApi()
    return response;
  }catch (error) {
    return rejectWithValue(error?.message || error);
  }
})

export const getCompanies = createAsyncThunk("crm/getCompanies" , async (_, { rejectWithValue }) => {
  try{
      const response = getCompaniesApi()
      return response;
  }catch (error) {
    return rejectWithValue(error?.message || error);
  }
})

export const addNewCompanies = createAsyncThunk("crm/addNewCompanies" , async (companies, { rejectWithValue }) => {
  try{
    const response = addNewCompaniesApi(companies)
    toast.success("Company Added Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Company Added Failed", { autoClose: 3000 });
    return rejectWithValue(error?.message || error);
  }
})

export const updateCompanies = createAsyncThunk("crm/updateCompanies" , async (companies, { rejectWithValue }) => {
  try{
    const response = updateCompaniesApi(companies)
    toast.success("Company Updated Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Company Updated Failed", { autoClose: 3000 });
    return rejectWithValue(error?.message || error);
  }
})

export const deleteCompanies = createAsyncThunk("crm/deleteCompanies" , async (companies, { rejectWithValue }) => {
  try{
    const response = deleteCompaniesApi(companies)
    toast.success("Company Deleted Successfully", { autoClose: 3000 });
    return { companies, ...response };
  }catch (error) {
    toast.error("Company Deleted Failed", { autoClose: 3000 });
    return rejectWithValue(error?.message || error);
  }
})

export const addNewContact = createAsyncThunk("crm/addNewContact" , async (contact, { rejectWithValue }) => {
  try{
    const response = addNewContactApi(contact)
    toast.success("Contact Added Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Contact Added Failed", { autoClose: 3000 });
    return rejectWithValue(error?.message || error);
  }
})

export const updateContact = createAsyncThunk("crm/updateContact" , async (contact, { rejectWithValue }) => {
  try{
    const response = updateContactApi(contact)
    toast.success("Contact Updated Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Contact Updated Failed", { autoClose: 3000 });
    return rejectWithValue(error?.message || error);
  }
})

export const deleteContact = createAsyncThunk("crm/deleteContact" , async (contact, { rejectWithValue }) => {
  try{
    const response = deleteContactApi(contact)
    toast.success("Contact Deleted Successfully", { autoClose: 3000 });
    return { contact, ...response };
  }catch (error) {
    toast.error("Contact Deleted Failed", { autoClose: 3000 });
    return rejectWithValue(error?.message || error);
  }
})

export const getLeads = createAsyncThunk(
  "crm/getLeads",
  async (
    {
      page = 1,
      pageLimit = 25,
      search = "",
      order = "ASC",
      orderBy = "",
      cvid = null,
    } = {},
    { rejectWithValue }
  ) => {

    try {

      const response = await fetchPortalLeads({
        cvid,
        page,
        pageLimit,
        search,
        order,
        orderBy,
      });

      console.log(
        "getLeads thunk response:",
        response
      );

      return response;

    } catch (error) {

      console.error(
        "getLeads thunk error:",
        error
      );

      return rejectWithValue(
        error?.message ||
        "Failed to fetch leads"
      );
    }
  }
);

export const getLeadFilters = createAsyncThunk(
  "crm/getLeadFilters",
  async (_, { rejectWithValue }) => {

    try {

      const response = await fetchLeadFilters();

      console.log(
        "Lead Filters Response:",
        response
      );

      return response;

    } catch (error) {

      console.error(
        "Lead Filters Error:",
        error
      );

      return rejectWithValue(
        error?.message ||
        "Failed to fetch lead filters"
      );
    }
  }
);


export const addNewLead = createAsyncThunk(
  "crm/addNewLead",
  async (lead, { rejectWithValue }) => {
    try {
      const response = await createPortalLead(lead);

      toast.success("Lead Added Successfully", {
        autoClose: 3000,
      });

      return response;
    } catch (error) {
      toast.error(error?.message || "Lead Added Failed");

      return rejectWithValue(error?.message || error);
    }
  }
);

export const updateLead = createAsyncThunk(
  "crm/updateLead",
  async (lead, { rejectWithValue }) => {
    try {
      const response = await updateLeadApi(lead);

      console.log("UPDATE LEAD CRM RESPONSE:", response);

      toast.success("Lead Updated Successfully", {
        autoClose: 3000
      });

      return response;
    } catch (error) {
      console.error("UPDATE LEAD CRM ERROR:", error);

      toast.error("Lead Updated Failed", {
        autoClose: 3000
      });

      return rejectWithValue(
        error?.message || "Lead Updated Failed"
      );
    }
  }
);

export const deleteLead = createAsyncThunk("crm/deleteLead" , async (leads, { rejectWithValue }) => {
  try{
    const response = deleteLeadApi(leads)
    toast.success("Lead Deleted Successfully", { autoClose: 3000 });
    return { leads, ...response };

  }catch (error) {
    toast.error("Lead Deleted Failed", { autoClose: 3000 });
    return rejectWithValue(error?.message || error);
  }
})

export const getDeals = createAsyncThunk("crm/getDeals" , async (_, { rejectWithValue }) => {
  try{
    const response = getDealsApi()
    return response;
  }catch (error) {
    return rejectWithValue(error?.message || error);
  }
})

